// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"95":"b6be62d0","164":"4d75630c","316":"303156f8","787":"597d0830"}[chunkId] + ".css";
};